import React, { useState } from "react";
import style from "../LerningDetail/LearningDetail.module.css";
import { useNavigate } from "react-router-dom";
import LeftArrow from "../../assests/LeftArrow.png";

const CreateSkill = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Placeholder – wire to actual create-skill API when ready
    console.log("Create skill payload:", { name, description });
  };

  return (
    <div className={style.container}>
      <div className={style.header}>
        <div className={style.headerLeft}>
          <button
            className={style.backButton}
            onClick={() => {
              navigate("/skills");
            }}
          >
            <img src={LeftArrow} alt="Back" />
          </button>
          <div className={style.headerTitle}>
            <h1>Learnings</h1>
            <p className={style.breadcrumb}>Skills / Create Skill</p>
          </div>
        </div>
      </div>

      <div className={style.LessonDiv}>
        <div className={style.courseHeader}>
          <h2>Create a new skill</h2>
        </div>

        <form
          onSubmit={handleSubmit}
          style={{ maxWidth: "600px", marginLeft: "1rem" }}
        >
          <div style={{ marginBottom: "1rem" }}>
            <label
              style={{
                display: "block",
                marginBottom: "0.25rem",
                fontSize: "0.9rem",
                fontWeight: 600,
                color: "#4b5563",
              }}
            >
              Skill Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{
                width: "100%",
                padding: "0.6rem 0.75rem",
                borderRadius: "0.5rem",
                border: "1px solid #d1d5db",
                fontSize: "0.95rem",
              }}
              placeholder="e.g. Machine Learning with Python"
              required
            />
          </div>

          <div style={{ marginBottom: "1.25rem" }}>
            <label
              style={{
                display: "block",
                marginBottom: "0.25rem",
                fontSize: "0.9rem",
                fontWeight: 600,
                color: "#4b5563",
              }}
            >
              Description
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={4}
              style={{
                width: "100%",
                padding: "0.6rem 0.75rem",
                borderRadius: "0.5rem",
                border: "1px solid #d1d5db",
                fontSize: "0.95rem",
                resize: "vertical",
              }}
              placeholder="Short description of this skill and what it covers"
              required
            />
          </div>

          <button
            type="submit"
            style={{
              padding: "0.6rem 1.5rem",
              borderRadius: "999px",
              border: "none",
              background:
                "linear-gradient(135deg, #0151CD 0%, #0369A1 100%)",
              color: "#fff",
              fontWeight: 600,
              fontSize: "0.95rem",
              cursor: "pointer",
            }}
          >
            Save Skill
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateSkill;

